import React, {useState,Component} from "react";
import styled from "styled-components";
const checkboxTick = require("../../../../assets/imgs/checkbox_tick.png");
const checkboxUntick = require("../../../../assets/imgs/uncheck.png");


class CreditRewardsStock extends Component {
  constructor(props) {
        super(props);
        this.state = {
          creditRewardStockData:[],
          data:this.props.creditRewardsStock,
        };
      }

    componentDidMount(){

      let array = []
      this.state.data.forEach(element => {
        array.push({name:element,checkedState:false})
      });

      this.setState({
        creditRewardStockData:array
      })
    }

    handleChange(index,value){

      let array = [...this.state.creditRewardStockData]

      array[index].checkedState = !value;
      this.setState({
        creditRewardStockData:array
      })
    }

  handleProceed() {

    let sendData = []
    this.state.creditRewardStockData.forEach(item => {
      if(item.checkedState == true){
        sendData.push(item.name)
      }
  })

    if (sendData.length == 0) {
          this.props.overlayMessageToggle("Please select atleast 1 item");
    } else {

 

     // console.log(sendData)

      let inputString = "Proceed" + "<split>" + JSON.stringify(sendData);
      window["autosubmit"](inputString);

      document.querySelectorAll('.action-elem').forEach(item => {
        item.classList.add('disabled')
      })

      document.querySelectorAll('.sf-stock-checkbox').forEach(item => {
        item.classList.add('disabled')
      })

      document.querySelectorAll('.stockBlock').forEach(item => {
        item.classList.add('stockOpacity')
      })              
    }
  }

  render(){
    return(
      <CreditRewardsStockWrapper className="mainWrapper">
        {this.state.creditRewardStockData.map((item, index) => {
          return(
            <div key={index}className="stockBlock">

              <label className="stock-container">
                   {item.name}
                    <input type="checkbox" checked="checked"
                       className="sf-stock-checkbox"
                       type="checkbox"
                       checked={item.checkedState}
                       onChange={()=>this.handleChange(index,item.checkedState)}
                    ></input>
                    <span className="checkmark"></span>
              </label>
              {/* <div className="stockCheckBox"> 
               <input
                className="sf-stock-checkbox"
                type="checkbox"
                checked={item.checkedState}
                onChange={()=>this.handleChange(index,item.checkedState)}
               ></input>
              </div>
              <div className="stockItemName">
               {item.name}
              </div> */}
            </div>
          )
        })}

        <div className= "action-elem"
          style={{marginTop:"16px"}}
          onClick={() => this.handleProceed()}>
          Proceed
        </div>
      </CreditRewardsStockWrapper>
    )
  } 
}

const CreditRewardsStockWrapper = styled.div`

  .stockBlock{
    margin: 12px 12px 0px 12px;
    border: 1px solid #fcfcfc;
    border-radius: 4px;
    box-shadow: 0px 5px 12px rgba(0, 0, 0, 0.2);
    background: #fcfcfc;
    padding: 10px 20px;
    font-size: 13px;
  }

.stock-container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin: 6px 0px;
  cursor: pointer;
  font-size: 13px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

  /* Hide the browser's default checkbox */
  .stock-container input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
  }

  /* Create a custom checkbox */
        .checkmark {
            position: absolute;
            top: 0;
            left: 0;
            height: 16px;
            width: 16px;
            background-color: #eee;
        }

        /* On mouse-over, add a grey background color */
        .stock-container:hover input ~ .checkmark {
            background-color: #ccc;
        }

        /* When the checkbox is checked, add a blue background */
        .stock-container input:checked ~ .checkmark {
            background-color: #2196F3;
        }
        /* Create the checkmark/indicator (hidden when not checked)  */
        .checkmark:after {
            content: "";
            position: absolute;
            display: none;
        }

        /* Show the checkmark when checked */
        .stock-container input:checked ~ .checkmark:after {
            display: block;
        }

        .stock-container .checkmark:after {
          left: 4px;
          top: 0px;
          width: 5px;
          height: 10px;
          border: solid white;
          border-width: 0 3px 3px 0;
          -webkit-transform: rotate(45deg);
          -ms-transform: rotate(45deg);
          transform: rotate(45deg);
      }
`

 export default CreditRewardsStock;